export const REVIEW_OF_COMPANY_TAGS = {
  POSITIVE: {
    FAIR_COMPENSATION: {
      key: 'fair_compensation',
      text: '報酬が妥当'
    },
    APPROPRIATE_REVIEW: {
      key: 'appropriate_review',
      text: '審査が適切'
    },
    CLEAR_PROCESS: {
      key: 'clear_process',
      text: '作業プロセスが分かりやすい'
    },
    GOOD_COMMUNICATION: {
      key: 'good_communication',
      text: '円滑なコミュニケーション'
    }
  },
  NEGATIVE: {
    UNFAIR_COMPENSATION: {
      key: 'unfair_compensation',
      text: '報酬が不当'
    },
    POOR_REVIEW: {
      key: 'poor_review',
      text: '審査が不適切'
    },
    UNCLEAR_PROCESS: {
      key: 'unclear_process',
      text: '作業プロセスが不明確'
    },
    POOR_COMMUNICATION: {
      key: 'poor_communication',
      text: 'コミュニケーションに問題あり'
    }
  }
}
